var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"mb-3"},[_c('b-col',[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('div',{staticClass:"p-wrapper"},[(_vm.text)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e()])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }